/** @jsx jsx */
import { jsx } from '@emotion/react'
import { Fragment } from 'react'
import { MesquitaStyle, diferenciaisStyle, visaoMissaoValoresStyle, estruturaStyle } from '../assets/styles/InternasContent.styles'
import { Col, Container, Row } from 'react-bootstrap'
import SliderEstrutura from '@/components/SliderEstrutura';
import ImgMesquita from '../assets/images/LP-arabe/img-mesquita-1.png'
import ImgMesquita2 from '../assets/images/LP-arabe/img-mesquita-2.png'
import ImgMMesquita from '../assets/images/LP-arabe/img-m-mesquita-1.png'
import ImgMMesquita2 from '../assets/images/LP-arabe/img-m-mesquita-2.png'
import IconMVV from '../assets/images/LP-arabe/ico-mvv.svg'
import BgMobile from '../assets/images/LP-arabe/bg-mesquita-m.png'

const MesquitaContent = () => {
  return (
    <Fragment>
      <section css={MesquitaStyle}>
        <div>
          <img src={BgMobile} className="img-mobile" />
        </div>
        <Container>
          <Row className='title-sec'>
            <Col lg={6} md={6} sm={12}>
              <h1>Conexão com a Mesquita e apoio das lideranças religiosas </h1>
              <p className='p-bottom'>Integrante da Rede Bertoni – referência em educação, nossa escola valoriza a cultura e os princípios islâmicos em todo o processo educativo.</p>
            </Col>
          </Row>
        </Container>
      </section>
      <section css={diferenciaisStyle}>
        <Container className='diferencias-sec'>
          <Row>
            <Col lg={12} md={12} sm={12}>
              <h2>Mesquita <span>Omar Ibn Al-Khattab</span></h2>
            </Col>
          </Row>
          <Row data-aos="fade-down" data-aos-delay="500">
            <Col lg={7} md={7} sm={12} className="d-none d-md-block">
              <img src={ImgMesquita} alt='Educação que prepara para liderar e prosperar' />
            </Col>
            <Col lg={7} md={7} sm={12} className="d-block d-md-none">
              <img src={ImgMMesquita} style={{ marginBottom: 32 }} alt='Educação que prepara para liderar e prosperar' />
            </Col>
            <Col lg={1} md={1} sm={12} />
            <Col lg={4} md={4} sm={12}>
              <p>A Escola Árabe Bertoni mantém uma relação profunda e integrada com a Mesquita de Foz do Iguaçu e com as lideranças religiosas da comunidade islâmica local. Essa parceria é um dos pilares da identidade da escola e está presente em seu dia a dia escolar.</p>
              <p>Localizada dentro do Centro Cultural Brasileiro Islâmico (CCBI), a escola compartilha o mesmo espaço da Mesquita, o que permite que os alunos vivenciem os valores e a espiritualidade islâmica no cotidiano.</p>
            </Col>
          </Row>
          <Row data-aos="fade-down" data-aos-delay="500" className='row-2'>
            <Col lg={4} md={4} sm={12} className="d-block d-md-none">
              <img src={ImgMMesquita2} style={{ marginBottom: 32 }} alt='Educação que prepara para liderar e prosperar' />
            </Col>
            <Col lg={7} md={7} sm={12}>
              <p>A proximidade facilita a participação em orações, celebrações religiosas e atividades culturais, fortalecendo a fé e o pertencimento desde a infância.</p>
              <p>A proposta pedagógica foi construída com o apoio da direção do CCBI, garantindo total alinhamento com os princípios do Islã sunita. Líderes religiosos da comunidade atuam como referências espirituais e culturais, participando de eventos, palestras e ações formativas com as famílias e os alunos.  O ensino religioso é baseado em materiais didáticos produzidos na Arábia Saudita e traduzidos para o português, assegurando autenticidade e respeito às tradições.</p>
            </Col>
            <Col lg={1} md={1} sm={12} />
            <Col lg={4} md={4} sm={12} className="d-none d-md-block">
              <img src={ImgMesquita2} alt='Educação que prepara para liderar e prosperar' />
            </Col>
          </Row>
        </Container>
      </section>
      <section css={estruturaStyle} id="estrutura">
        <Container>
          <Row data-aos="fade-down" data-aos-delay="500">
            <Col lg={6} md={6} sm={12}>
              <h2>Conheça nossa <span>estrutura</span></h2>
            </Col>
            <Col lg={1} md={1} sm={12} />
            <Col lg={5} md={5} sm={12}>
              <p>Nossa escola foi planejada para proporcionar conforto, segurança e experiências significativas. Com salas amplas, espaços integrados</p>
            </Col>
          </Row>
        </Container>
      </section>
      <SliderEstrutura />
      <section css={visaoMissaoValoresStyle}>
        <Container>
          <Row>
            <Col lg={4} md={4} sm={12}>
              <div className='box-1'>
                <img src={IconMVV}  />
                <h3>Missão</h3>
                <p>Oferecer uma educação transformadora e moderna, pautada nos princípios islâmicos, que prepara os alunos para prosperar e liderar com ética em um mundo em constante mudança.</p>
              </div>
            </Col>
            <Col lg={4} md={4} sm={12}>
              <div className='box-2'>
                <img src={IconMVV}  />
                <h3>Visão</h3>
                <p>Ser referência nacional em educação infantil e fundamental, unindo tradição árabe e inovação pedagógica, formando cidadãos ativos na sociedade brasileira e muçulmana.</p>
              </div>
            </Col>
            <Col lg={4} md={4} sm={12}>
              <div className='box-1'>
                <img src={IconMVV}  />
                <h3>Valores</h3>
                <ul>
                  <li>- Formação emocional e religiosa fundamentada na cultura islâmica sunita</li>
                  <li>- Respeito à família, aos professores e à comunidade</li>
                  <li>- Ensino trilíngue de excelência (árabe, português e inglês)</li>
                  <li>- Tradição, inovação e vínculos afetivos na rotina escolar</li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </Fragment>

  )
}

export default MesquitaContent
